function game_304()
{

}

game_304.odd_map  = {
  "9":[0,0,100,350,1000],
  "8":[0,0,20,100,500],
  "7":[0,0,10,40,350],
  "6":[0,0,10,40,200],
  "5":[0,0,5,20,100],
  "4":[0,0,5,20,100],
  "3":[0,0,5,10,50],
  "2":[0,0,5,10,50],
  "1":[0,0,5,10,50],
};

export {
  game_304
};



// WEBPACK FOOTER //
// ./src/components/slots/game_304.js